import React, { Fragment, useContext } from 'react';
import PageContext from '../../contexts/pageContext';
import useTilesStyles from './styles';

import NextImageRenderer from '../../components/nextImageRenderer';

function Tiles({ sectionData, sectionIndex }) {
  const {
    isMobile,
    layout: { containerWidth },
    isPreview,
    isEdit
  } = useContext(PageContext);

  const classes = useTilesStyles({ isMobile });

  const nodeData = sectionData.components;

  const tilesList = nodeData[0]?.tilesList.components;

  const handleClick = (value) => {
    if (!isEdit && value) {
      if (value.indexOf('http://') == 0 || value.indexOf('https://') == 0) {
        window.open(value);
      } else {
        window.open('https://' + value);
      }
    }
  };

  const TileDiv = tilesList?.map((tile, i) => {
    return (
      <Fragment key={i}>
        <div
          className={classes.tileDiv}
          onClick={() => handleClick(tile.cta?.metadata?.value)}
        >
          {/* <img
            className={classes.tileImg}
            src={tile?.tileImage?.metadata?.value}
          /> */}
          <NextImageRenderer
            className={classes.tileImg}
            src={tile?.tileImage?.metadata?.value}
            sectionIndex={sectionIndex}
          />
          <div
            className={classes.title}
            ref={tile.tileName?.refSetter}
            dangerouslySetInnerHTML={{
              __html: tile?.tileName?.metadata?.value
            }}
          ></div>
        </div>
      </Fragment>
    );
  });

  return (
    <>
      <div className={classes.tileParentDiv}>
        <div
          className={classes.header}
          ref={nodeData[0].sectionHeader?.refSetter}
          dangerouslySetInnerHTML={{
            __html: nodeData[0].sectionHeader?.metadata?.value
          }}
        ></div>
        <div
          className={classes.headerTitle}
          ref={nodeData[0].sectionTitle?.refSetter}
          dangerouslySetInnerHTML={{
            __html: nodeData[0].sectionTitle?.metadata?.value
          }}
        ></div>
        <div className={classes.row}>{TileDiv}</div>
      </div>
    </>
  );
}

export default Tiles;
